import React, { useEffect, useContext, useRef, useMemo, useState } from 'react';
// import {AnimatePresence, motion} from 'framer-motion';
import { ShoppingList } from './ShoppingList'
// import { ScrollPosition } from '../../components/ScrollPosition'
import { useUserAPI } from '../../components/useUserAPI';
// import { NoBarcode } from './NoBarcode'
import { ShoppingStart } from '../../components/ShoppingStart';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
import { iAeonSetData } from '../../library/iaeon_sdk.js';
import { iAeonCheckSilentMode } from '../../library/iaeon_sdk.js';
import { iAeonGetPointBarCode } from '../../library/iaeon_sdk.js';

import useSound from 'use-sound';
// import se_07_scan from '../../sound/s07_scan.mp3';
import se_08 from '../../sound/s08_se_delay0.mp3';
import { zxingScan } from '../../components/ZxingScanUtil';

import soundUrl from '../../sound/kuji_lottery.mp3';

import { useSDK } from "../../scandit/sdk";

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const Shopping = (props) => {

// const [se07_scan] = useSound(se_07_scan);
const [se08_se] = useSound(se_08);
const [kujiLotterySE] = useSound(soundUrl, { volume: 0 });

const sharedInfo = useContext(SharedInfoContext);
const { bandColor, updateBandColor } = useContext(SharedInfoContext);
const { transactionno, updateTransactionno} = useContext(SharedInfoContext);

const { loaded, sdk } = useSDK();

useEffect(() => {
	// document.documentElement.classList.remove('is_fixed');
	// document.body.classList.remove('is_fixed');
	// document.documentElement.classList.add('is_fixed');
	// document.body.classList.add('is_fixed');
	if (document.getElementById('header')) {
		document.getElementById('header').classList.remove('is_behind');
		document.getElementById('header').classList.add('is_fixed');
	}
	var elements = document.getElementsByClassName('header_logo');
	Array.from(elements).forEach(function(element) {
		if (element) {
			element.classList.remove('is_hide');
		}
	});
	kujiLotterySE();


	//scandit SDK 開始
	// if(props.sdkStartFlg === false){
	// 	props.setSdkStartFlg(true);
	// }

	// if(props.cameraFirst === true){
	// 	props.setCameraFirst(false);
	// 	(async () => {
	// 		await sdk.enableCamera(true);
	// 	})();
	// }

	// if(props.scanFirst === true){
	// 	setTimeout(function(){
	// 		props.setScanFirst(false);
	// 		document.getElementById('scanBtn').classList.remove('is_disabled');
	// 	}, 1000);
	// }else{
	// 	props.setScanFirst(false);
	// 	document.getElementById('scanBtn').classList.remove('is_disabled');
	// }
	// props.setScanSetting(true);

	//arrows We 対応
	// document.documentElement.style.zoom = window.innerWidth / 390;
	// 	var zratio = window.innerWidth / 390;
	// if(window.innerWidth >= 320){
	// 	document.documentElement.style.zoom = window.innerWidth / 390;
	// 	var zratio = window.innerWidth / 390;
	// }else{
	// 	document.documentElement.style.zoom = 1;
	// 	var zratio = 1;
	// }
	// let hratio = window.innerHeight / (window.innerHeight * zratio);
	// let realheight = window.innerHeight * hratio;
	// let elementA = document.getElementById('scan');
	// if (elementA) {
	// 	elementA.style.height = realheight + 'px';
	// }
}, []);


//----------------------------------------
//スキャン
//----------------------------------------

useEffect(() => {
	//「スキャン」ボタン有効
	props.setIsScanButtonDisabled(false);
}, []);

const scanItem = () => {
	console.log("props.isScanButtonDisabled: "+props.isScanButtonDisabled);
	if(props.isScanButtonDisabled === true){
		console.log("scan_btn: skip");
	}else{
		console.log("scan_btn: click");
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
		//「スキャン」ボタン無効
		props.setIsScanButtonDisabled(true);

		console.log("REACT_APP_ZXING: " + process.env.REACT_APP_ZXING);
		if(process.env.REACT_APP_ZXING === "true"){ //ZXING有効
			console.log("ZXING 有効");
			zxingScan().then(data => {
				console.log("【iAeonDoCodeRead】zxing_result: " + data);
				// props.setSoundState("se07_scan");

				//商品登録API：レスポンス（zxing・MLkit用
				shoppingPurchaseAPI(data,ShoppingStartContext.data.token);

				//動作テスト
				// document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
				// 	element.classList.remove('is_show');
				// });
				// props.setIsScanButtonDisabled(false);

			}).catch(error => {
				document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
					if (element) {
						element.classList.remove('is_show');
					}
				});

				console.log("【iAeonDoCodeRead】error: ", error);
				console.log('【iAeonDoCodeRead】error: ' + error.error_code + " : " + error.message);

				props.setIsScanButtonDisabled(false);
				props.setSoundState("se08_se");
			});

		}else{ //ZXING無効 → scandit有効
			console.log("scandit有効");

			(async () => {
				// await sdk.enableScanning(true);
				await sdk.enableCamera(true);
			})();
			setTimeout(function(){
				document.getElementById('header').classList.add('is_behind');
				props.setScanFlg(false);
				props.setPage("scan")
			}, 400);
		}
		// se08_se();
		props.setSoundState("se08_se");
	}
}


//----------------------------------------
//商品登録API：レスポンス（zxing・MLkit用
//----------------------------------------

const { shoppingPurchaseAPI, data: shoppingPurchaseData, loading: shoppingPurchaseLoading, error: shoppingPurchaseError } = useUserAPI();

useEffect(() => {
	// console.log("useEffect purchaseData");
	if(shoppingPurchaseData){
		let timeout_time = 700;
		if(props.osinfo.os === "iOS"){
			timeout_time = 400;
		}
		// console.log("ああああ");
		if (shoppingPurchaseData.data) { //SUCCESS
			// console.log("いいいい");
			// props.setSoundState("se07_scan");

			console.log(`【shoppingPurchaseAPI】 receiptKanji: ${shoppingPurchaseData.data.receiptKanji}`);
			console.log(`【shoppingPurchaseAPI】 sellPrice: ${shoppingPurchaseData.data.sellPrice}`);
			console.log(`【shoppingPurchaseAPI】 discountSellPrice: ${shoppingPurchaseData.data.discountSellPrice}`);

			setTimeout(function(){
				props.setSoundState("se07_scan");
				props.setShoppingData(shoppingPurchaseData);
				props.setScanResultFlg(true);
				setTimeout(function(){
					props.setScanResultFlg(false);
					props.setIsScanButtonDisabled(false);
				}, 2500);
			}, timeout_time);

		}else{ //ERROR
			// console.log("うううう");
			console.log(`【shoppingPurchaseAPI】 errorCode: ${shoppingPurchaseData.errorCode}`);
			console.log(`【shoppingPurchaseAPI】 errorMessage: ${shoppingPurchaseData.errorMessage}`);
			console.log(`【shoppingPurchaseAPI】 isSuccess: ${shoppingPurchaseData.isSuccess}`);

			setTimeout(function(){
				if(shoppingPurchaseData.errorCode === "26"){
					//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
					props.setErrFlg(true);
					props.setErr([true,`${shoppingPurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
					// props.setErr([true,`${shoppingPurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				}else if(shoppingPurchaseData.errorCode === "27"){
					//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
					props.setErrFlg(true);
					props.setErr([true,`${shoppingPurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
					// props.setErr([true,`${shoppingPurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				}else{
					props.setErrFlg(true);
					props.setErr([true,`${shoppingPurchaseData.errorCode}`,`${shoppingPurchaseData.errorMessage}`]);
				}

				props.setSoundState("se07_scan");
				props.setIsScanButtonDisabled(false);
			}, timeout_time);
		}
	}
	if(shoppingPurchaseError){
		console.log("shoppingPurchaseError");
		console.log(shoppingPurchaseError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(shoppingPurchaseLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			if (element) {
				element.classList.remove('is_show');
			}
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			if (element) {
				element.classList.remove('is_show');
			}
		});
	}
}, [shoppingPurchaseData,shoppingPurchaseLoading,shoppingPurchaseError]);

// Zxing用 ---------------------------------------

const onNoBarcode = () => {
	props.setShowNoBarcode(true)
	// se08_se();
	props.setSoundState("se08_se");
}


//----------------------------------------
//お会計
//----------------------------------------

useEffect(() => {
	//「お会計」ボタンを有効化
	props.setIsKaikeiButtonDisabled(false);
}, []);

useEffect(() => {
	console.log("props.isKaikeiButtonDisabled: "+props.isKaikeiButtonDisabled);
}, [props.isKaikeiButtonDisabled]);

useEffect(() => {
	console.log("props.isScanButtonDisabled: "+props.isScanButtonDisabled);
}, [props.isScanButtonDisabled]);

useEffect(() => {
	console.log("props.isScanButtonDisabled: "+props.isScanButtonDisabled);
}, [props.isWaitingForOtb]);


//ログアップロードAPI
const { loguploadAPI, data: loguploadData, loading: loguploadLoading, error: loguploadError } = useUserAPI();


const ShowPayModal = () => {
	console.log("props.page: " + props.page);
	if(props.page === "shopping"){
	console.log("props.isKaikeiButtonDisabled: "+props.isKaikeiButtonDisabled);
	if (props.isKaikeiButtonDisabled === true){
		console.log("kaikei_btn:skip");
		return; // すでに無効化されていたら処理をスキップ
	}else {

		//「お会計」ボタンを無効化
		props.setIsKaikeiButtonDisabled(true);
		//「スキャン」ボタン無効
		props.setIsScanButtonDisabled(true);

		//「お支払いへ進む」ボタンがクリックされたか
		props.setIsWaitingForOtb(false);
		//「お支払いへ進む」ボタンの連打防止フラグ
		props.setIsButtonDisabled(false);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"kaikei_btn:click");

		//9.WAON POINTバーコード取得API（決済API、決済予約APIで使用 → 使用
		callAPI_9();

		props.setShowPayModal(true);

		// setOpen(true)
		// se08_se();
		props.setSoundState("se08_se");
		// setTimeout(function(){
		(async () => {
			// await sdk.enableScanning(true);
			await sdk.enableCamera(true);
		})();
		// }, 600);

		// setTimeout(function(){x
		// props.setScanActive("qrcode");
		// }, 600);

		// 一定時間後にボタンを再び有効化
		// setTimeout(() => {
		// 	if(props.showPayModal === false){
		// 		//「お会計」ボタンを有効化
		// 		props.setIsKaikeiButtonDisabled(false);
		// 	}
		// }, 2000); // 1秒後に再度有効化

	}
	}else {
		console.log("kaikei_btn:skip");
	}
}

//ログアップロードAPI レスポンス
useEffect(() => {
	if(loguploadData){
		console.log(loguploadData);
		if (loguploadData.isSuccess == true) { //SUCCESS
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
		}else{ //ERROR
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
			console.log(`【loguploadAPI】 errorCode: ${loguploadData.errorCode}`);
			console.log(`【loguploadAPI】 errorMessage: ${loguploadData.errorMessage}`);
		}
	}
}, [loguploadData]);


//----------------------------------------
//WAON POINTバーコード取得API
//----------------------------------------

//9.WAON POINTバーコード取得API（決済API、決済予約APIで使用 → 使用
function callAPI_9() {

	console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
	if (process.env.REACT_APP_IAEON_FLG === "true") {
		// OTBをリセットしてから処理を開始
		props.setOtb("");
		props.setIsFetchingOtb(true); //OTB取得開始
		console.log("----------------------------");
		console.log("【iAeonGetPointBarCode】call");
		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"iAeonGetPointBarCode:call");

		//30秒遅延エラーテスト
		// new Promise((_, reject) => setTimeout(() => reject({error_code:"TEST", message:"delay test"}), 30000))
		//5秒遅延エラーテスト
		// new Promise((_, reject) =>
		// 	setTimeout(() => reject({error_code: "TEST_DELAY", message: "5秒遅延エラーテスト"}), 5000)
		// )
		//反応なしテスト
		// new Promise(() => {})
		//正常系
		iAeonGetPointBarCode()
			.then((success) => { //OTB取得成功
				props.setOtbErr(false);
				console.log('【iAeonGetPointBarCode】success：' + success);
				console.log('【iAeonGetPointBarCode】code：' + success.code);
				//ログアップロードAPI
				loguploadAPI(sharedInfo.transactionno,"iAeonGetPointBarCode:success, code:" + success.code);
				// updateOtbCode(success.code);
				props.setOtb(success.code);

				//OTB取得失敗の動作確認用
				// [B] otb = "error"（初回取得失敗済み）
				// props.setOtbErr(true);
				// props.setOtb("error");
			})
			.catch((error) => { //OTB取得失敗
				props.setOtbErr(true);
				props.setOtb("error");
				console.log('【iAeonGetPointBarCode】error: ' + error.error_code + " : " + error.message);
				//ログアップロードAPI
				loguploadAPI(sharedInfo.transactionno,"iAeonGetPointBarCode:error, error_code:" + error.error_code + ", message:" + error.message);
			})
			.finally(() => {
				props.setIsFetchingOtb(false); //OTB取得完了
			});
	}
}


//----------------------------------------
//買物データ保存・削除
//----------------------------------------

useEffect(() => {

	if(props.shoppingData){

		if (props.shoppingData.data) { //SUCCESS
			console.log("【shoppingData】success");
			console.log(`【shoppingData】sumIncludeTaxPrice: ${props.shoppingData.data.sumIncludeTaxPrice}`);
			console.log(`【shoppingData】sumSellPrice: ${props.shoppingData.data.sumSellPrice}`);
			console.log(`【shoppingData】sumItemCount: ${props.shoppingData.data.sumItemCount}`);
			console.log("----");
			console.log(`【shoppingData】bonusAmount: ${props.shoppingData.data.campaign.bonusAmount}`);
			console.log(`【shoppingData】gustBonusAmount: ${props.shoppingData.data.campaign.gustBonusAmount}`);
			console.log("----");
			console.log(`【shoppingData】lotteryTimes: ${props.shoppingData.data.campaign.lotteryTimes}`);
			console.log(`【shoppingData】gustLotteryAmount: ${props.shoppingData.data.campaign.gustLotteryAmount}`);
			if(props.shoppingData.data.resultItemMasterList){
				console.log("----");
				console.log(`【shoppingData】resultItemMasterList receiptKanji: ${props.shoppingData.data.resultItemMasterList[0].receiptKanji}`);
				console.log(`【shoppingData】resultItemMasterList count: ${props.shoppingData.data.resultItemMasterList[0].count}`);
				console.log(`【shoppingData】resultItemMasterList sellPrice: ${props.shoppingData.data.resultItemMasterList[0].sellPrice}`);
				console.log(`【shoppingData】resultItemMasterList itemUrl: ${props.shoppingData.data.resultItemMasterList[0].itemUrl}`);
			}
			if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
				if(props.shoppingData.data.sumSellPrice !== 0){
					callAPI_18(sharedInfo.transactionno);
				}else {
					callAPI_18_delete();
				}
			}
		}else{ //ERROR
			console.log("【shoppingData】no data");
		}
	}else{
		console.log("【shoppingData】no data");
	}
}, [props.shoppingData]);


const ShoppingStartContext = useContext(ShoppingStart);


//18.データ保存API
function callAPI_18(transac){
	console.log("----------------------------");
	console.log("【iAeonSetData】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData】success：' + aaa);
		// console.log('【iAeonSetData】onetime_token：' + aaa.onetime_token);
    }
    let errorCall_18 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonSetData】error: ' + error.error_code + " : " + error.message);
		if(bbb.error_code === "000068"){
			iAeonSetData({"mode":"put", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
			// window.iAeonMiniApp.iAeonSetData({"mode":"put", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
		}
    }
	// 現在の日付と時刻を取得
	const today = new Date();
	// 日付を YYYY-MM-DD 形式で表示
	const dateString = today.toISOString().split('T')[0];
	console.log("【iAeonSetData】本日の日付: "+dateString);

    let shoppingData = {
		transactionno: transac,
		storeCode: sharedInfo.storeCode,
		date: dateString
    }
    const shoppingJSON = JSON.stringify(shoppingData);
    iAeonSetData({"mode":"add", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
    // window.iAeonMiniApp.iAeonSetData({"mode":"add", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
    // window.iAeonMiniApp.iAeonSetData({"mode":"put", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
	// window.iAeonMiniApp.iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
}

//18.データ保存API（削除
function callAPI_18_delete(){
	console.log("----------------------------");
	console.log("【iAeonSetData】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData】success：');
		console.log(aaa);
    }
    let errorCall_18 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonSetData】error: ' + error.error_code + " : " + error.message);
		console.log(bbb);
    }
    // window.iAeonMiniApp.iAeonSetData({"mode":"add", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
    // window.iAeonMiniApp.iAeonSetData({"mode":"put", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
	iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
	// window.iAeonMiniApp.iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
}


//----------------------------------------
//バナースライダー
//----------------------------------------

const sliderRef = useRef(null);

const settings = {
	autoplay: true,
	autoplaySpeed: 6000,
	speed: 500,
	// cssEase: "ease-out",
	useCss: true,
	dots: false,
	infinite: true,
	arrows: false,
	draggable: true,
	mobileFirst: true,
	initialSlide: props.activeBnSlide,
	touchThreshold: 200,
	verticalSwiping: false,
	slidesToShow: 1,
	centerMode: false,
	// variableWidth: true,
	slidesToScroll: 1,
	afterChange: (current, next) => {
		props.setActiveBnSlide(current);
	}
}


const onBnPrevBtn = (e) => {
    // e.preventDefault();
	// se08_se();
	if (sliderRef.current) {
		sliderRef.current.slickPrev();
	}
	// setTimeout(function(){
	// 	props.setSoundState("se08_se");
	// }, 100);
	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//24.サイレントモードチェックAPI
		callAPI_24();
	}else{ //iAEON無効
		se08_se();
	}
};

const onBnNextBtn = (e) => {
    // e.preventDefault();
	// se08_se();
	if (sliderRef.current) {
		sliderRef.current.slickNext();
	}
	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//24.サイレントモードチェックAPI
		callAPI_24();
	}else{ //iAEON無効
		se08_se();
	}
};


//----------------------------------------
//サイレントモードチェックAPI
//----------------------------------------

//24.サイレントモードチェックAPI
function callAPI_24(){
    let successCall_24 = function(success){
        var aaa = success;
		console.log('【iAeonCheckSilentMode】success：' + aaa);
		console.log('【iAeonCheckSilentMode】is_silent_mode：' + aaa.is_silent_mode);

		if(aaa.is_silent_mode != true){
			se08_se();
		}
    }
    let errorCall_24 = function(error){
		console.log('【iAeonCheckSilentMode】error: ' + error.error_code + " : " + error.message);
    }
	console.log("----------------------------");
	console.log('【iAeonCheckSilentMode】call');
    iAeonCheckSilentMode().then(successCall_24).catch(errorCall_24);
}


//----------------------------------------
//バナーコンポーネント
//----------------------------------------

const BannerComponent = ({shopData}) => {
	if(ShoppingStartContext.data){
		if (ShoppingStartContext.data.bonusFlag === 1 && ShoppingStartContext.data.lotteryFlag === 0) { //ボーナス有効、くじ無効
			if(shopData){
				if (shopData.data) { //SUCCESS

					if(shopData.data.campaign.gustBonusAmount === 0 && shopData.data.campaign.bonusAmount === 0){ //売上なし
						return (
							<div className="regigoBanner regigoBanner_bonus">
								<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
							</div>
						)
					}else if(shopData.data.campaign.gustBonusAmount === 0 && shopData.data.campaign.bonusAmount !== 0){ //上限金額
						return (
							<div className="regigoBanner regigoBanner_bonus">
								<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus03.png" alt="" width="358" height="72" /></span>
								<div className="regigoBanner_bonusCount">
									<div>
										<span>¥ </span>
								{shopData.data.campaign.bonusAmount ? (shopData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}
									</div>
								</div>
							</div>
						)
					}else{ //通常表示
						return (
							<div className="regigoBanner regigoBanner_bonus">
								<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus02.png" alt="" width="358" height="72" /></span>
								<div className="regigoBanner_bonusPrice">
									{/* 1,234 */}
									{shopData.data.campaign.gustBonusAmount ? (shopData.data.campaign.gustBonusAmount).toLocaleString('ja-JP') : 0}
								</div>
								<div className="regigoBanner_bonusCount">
									<div>
										<span>¥ </span>
									{shopData.data.campaign.bonusAmount ? (shopData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}
									</div>
								</div>
							</div>
						)
					}

				}else{ //売上なし
					return (
						<div className="regigoBanner regigoBanner_bonus">
							<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
						</div>
					)
				}
			}else{ //売上なし
				return (
					<div className="regigoBanner regigoBanner_bonus">
						<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
					</div>
				)
			}

		}else if (ShoppingStartContext.data.bonusFlag === 0 && ShoppingStartContext.data.lotteryFlag === 1) { //ボーナス無効、くじ有効

			if(shopData){
				if (shopData.data) { //SUCCESS

					if(shopData.data.campaign.gustLotteryAmount === 0 && shopData.data.campaign.lotteryTimes === 0){ //売上なし
						return (
							<div className="regigoBanner regigoBanner_kuji">
								<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
							</div>
						)
					}else if(shopData.data.campaign.gustLotteryAmount === 0 && shopData.data.campaign.lotteryTimes !== 0){ //上限回数
						return (
							<div className="regigoBanner regigoBanner_kuji">
								<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji03.png" alt="" width="358" height="72" /></span>
								<div className="regigoBanner_kujiCount">
									{/* 99 */}
									{shopData.data.campaign.lotteryTimes ? shopData.data.campaign.lotteryTimes : 0}
								</div>
							</div>
						)
					}else{ //通常表示
						return (
							<div className="regigoBanner regigoBanner_kuji">
								<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji02.png" alt="" width="358" height="72" /></span>
								<div className="regigoBanner_kujiPrice">
									{/* 2,345 */}
									{shopData.data.campaign.gustLotteryAmount ? (shopData.data.campaign.gustLotteryAmount).toLocaleString('ja-JP') : 0}
								</div>
								<div className="regigoBanner_kujiCount">
									{shopData.data.campaign.lotteryTimes ? shopData.data.campaign.lotteryTimes : 0}
								</div>
							</div>
						)
					}

				}else{ //売上なし
					return (
						<div className="regigoBanner regigoBanner_kuji">
							<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
						</div>
					)
				}
			}else{ //売上なし
				return (
					<div className="regigoBanner regigoBanner_kuji">
						<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
					</div>
				)
			}
		}else if (ShoppingStartContext.data.bonusFlag === 1 && ShoppingStartContext.data.lotteryFlag === 1) { //ボーナス有効、くじ有効

			if(shopData){ //ボーナス
				if (shopData.data) { //SUCCESS
					if(shopData.data.campaign.gustBonusAmount === 0 && shopData.data.campaign.bonusAmount === 0){ //ボーナス売上なし
						if(shopData.data.campaign.gustLotteryAmount === 0 && shopData.data.campaign.lotteryTimes === 0){ //くじ売上なし
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
									<div className="regigoBannerSlide_box">
										<div className="regigoBanner regigoBanner_bonus">
											<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
										</div>
									</div>
									<div className="regigoBannerSlide_box">
										<div className="regigoBanner regigoBanner_kuji">
											<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
										</div>
									</div>
								</Slider>
								<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
									<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
								</div>
								<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
									<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
								</div>
							</div>
							)
						}else if(shopData.data.campaign.gustLotteryAmount === 0 && shopData.data.campaign.lotteryTimes !== 0){ //くじ上限回数
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
									<div className="regigoBannerSlide_box">
										<div className="regigoBanner regigoBanner_bonus">
											<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
										</div>
									</div>
									<div className="regigoBannerSlide_box">
										<div className="regigoBanner regigoBanner_kuji">
											<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji03.png" alt="" width="358" height="72" /></span>
											<div className="regigoBanner_kujiCount">
												{/* 99 */}
												{shopData.data.campaign.lotteryTimes ? shopData.data.campaign.lotteryTimes : 0}
											</div>
										</div>
									</div>
								</Slider>
									<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
										<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
									</div>
									<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
										<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
									</div>
								</div>
							)
						}else{ //くじ通常表示
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
									<div className="regigoBannerSlide_box">
										<div className="regigoBanner regigoBanner_bonus">
											<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
										</div>
									</div>
									<div className="regigoBannerSlide_box">
										<div className="regigoBanner regigoBanner_kuji">
											<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji02.png" alt="" width="358" height="72" /></span>
											<div className="regigoBanner_kujiPrice">
												{/* 2,345 */}
												{shopData.data.campaign.gustLotteryAmount ? (shopData.data.campaign.gustLotteryAmount).toLocaleString('ja-JP') : 0}
											</div>
											<div className="regigoBanner_kujiCount">
												{shopData.data.campaign.lotteryTimes ? shopData.data.campaign.lotteryTimes : 0}
											</div>
										</div>
									</div>
								</Slider>
									<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
										<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
									</div>
									<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
										<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
									</div>
								</div>
							)
						}
					}else if(shopData.data.campaign.gustBonusAmount === 0 && shopData.data.campaign.bonusAmount !== 0){ //ボーナス上限金額
						if(shopData.data.campaign.gustLotteryAmount === 0 && shopData.data.campaign.lotteryTimes === 0){ //くじ売上なし
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_bonus">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus03.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_bonusCount">
											<div>
												<span>¥ </span>
										{shopData.data.campaign.bonusAmount ? (shopData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}
											</div>
										</div>
									</div>
								</div>
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_kuji">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
									</div>
								</div>
								</Slider>
								<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
									<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
								</div>
								<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
									<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
								</div>
							</div>
							)
						}else if(shopData.data.campaign.gustLotteryAmount === 0 && shopData.data.campaign.lotteryTimes !== 0){ //くじ上限回数
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_bonus">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus03.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_bonusCount">
											<div>
												<span>¥ </span>
										{shopData.data.campaign.bonusAmount ? (shopData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}
											</div>
										</div>
									</div>
								</div>
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_kuji">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji03.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_kujiCount">
											{/* 99 */}
											{shopData.data.campaign.lotteryTimes ? shopData.data.campaign.lotteryTimes : 0}
										</div>
									</div>
								</div>
								</Slider>
								<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
									<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
								</div>
								<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
									<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
								</div>
							</div>
							)
						}else{ //くじ通常表示
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_bonus">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus03.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_bonusCount">
											<div>
												<span>¥ </span>
										{shopData.data.campaign.bonusAmount ? (shopData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}
											</div>
										</div>
									</div>
								</div>
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_kuji">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji02.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_kujiPrice">
											{/* 2,345 */}
											{shopData.data.campaign.gustLotteryAmount ? (shopData.data.campaign.gustLotteryAmount).toLocaleString('ja-JP') : 0}
										</div>
										<div className="regigoBanner_kujiCount">
											{shopData.data.campaign.lotteryTimes ? shopData.data.campaign.lotteryTimes : 0}
										</div>
									</div>
								</div>
								</Slider>
								<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
									<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
								</div>
								<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
									<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
								</div>
							</div>
							)
						}
					}else{ //ボーナス通常表示
						if(shopData.data.campaign.gustLotteryAmount === 0 && shopData.data.campaign.lotteryTimes === 0){ //くじ売上なし
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_bonus">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus02.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_bonusPrice">
											{/* 1,234 */}
											{shopData.data.campaign.gustBonusAmount ? (shopData.data.campaign.gustBonusAmount).toLocaleString('ja-JP') : 0}
										</div>
										<div className="regigoBanner_bonusCount">
											<div>
												<span>¥ </span>
											{shopData.data.campaign.bonusAmount ? (shopData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}
											</div>
										</div>
									</div>
								</div>
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_kuji">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
									</div>
								</div>
								</Slider>
								<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
									<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
								</div>
								<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
									<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
								</div>
							</div>
							)
						}else if(shopData.data.campaign.gustLotteryAmount === 0 && shopData.data.campaign.lotteryTimes !== 0){ //くじ上限回数
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_bonus">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus02.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_bonusPrice">
											{/* 1,234 */}
											{shopData.data.campaign.gustBonusAmount ? (shopData.data.campaign.gustBonusAmount).toLocaleString('ja-JP') : 0}
										</div>
										<div className="regigoBanner_bonusCount">
											<div>
												<span>¥ </span>
											{shopData.data.campaign.bonusAmount ? (shopData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}
											</div>
										</div>
									</div>
								</div>
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_kuji">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji03.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_kujiCount">
											{/* 99 */}
											{shopData.data.campaign.lotteryTimes ? shopData.data.campaign.lotteryTimes : 0}
										</div>
									</div>
								</div>
								</Slider>
								<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
									<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
								</div>
								<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
									<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
								</div>
							</div>
							)
						}else{ //くじ通常表示
							return (
								<div className="regigoBannerSlide_frame">
								<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_bonus">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus02.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_bonusPrice">
											{/* 1,234 */}
											{shopData.data.campaign.gustBonusAmount ? (shopData.data.campaign.gustBonusAmount).toLocaleString('ja-JP') : 0}
										</div>
										<div className="regigoBanner_bonusCount">
											<div>
												<span>¥ </span>
											{shopData.data.campaign.bonusAmount ? (shopData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}
											</div>
										</div>
									</div>
								</div>
								<div className="regigoBannerSlide_box">
									<div className="regigoBanner regigoBanner_kuji">
										<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji02.png" alt="" width="358" height="72" /></span>
										<div className="regigoBanner_kujiPrice">
											{/* 2,345 */}
											{shopData.data.campaign.gustLotteryAmount ? (shopData.data.campaign.gustLotteryAmount).toLocaleString('ja-JP') : 0}
										</div>
										<div className="regigoBanner_kujiCount">
											{shopData.data.campaign.lotteryTimes ? shopData.data.campaign.lotteryTimes : 0}
										</div>
									</div>
								</div>
								</Slider>
								<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
									<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
								</div>
								<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
									<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
								</div>
							</div>
							)
						}
					}

				}else{ //ボーナス売上なし、くじ売上なし
					return (
						<div className="regigoBannerSlide_frame">
						<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
						<div className="regigoBannerSlide_box">
							<div className="regigoBanner regigoBanner_bonus">
								<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
							</div>
						</div>
						<div className="regigoBannerSlide_box">
							<div className="regigoBanner regigoBanner_kuji">
								<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
							</div>
						</div>
						</Slider>
							<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
								<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
							</div>
							<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
								<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
							</div>
						</div>
					)
				}
			}else{ //ボーナス売上なし、くじ売上なし
				return (
					<div className="regigoBannerSlide_frame">
					<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
					<div className="regigoBannerSlide_box">
						<div className="regigoBanner regigoBanner_bonus">
							<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
						</div>
					</div>
					<div className="regigoBannerSlide_box">
						<div className="regigoBanner regigoBanner_kuji">
							<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
						</div>
					</div>
					</Slider>
						<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
							<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
						</div>
						<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
							<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
						</div>
					</div>
				)
			}
		}
	}
};

// const BannerComponentMemo = useMemo(() => {
//     return <BannerComponent shopData={props.shoppingData} />;
// }, [props.shoppingData]);

// const BannerSlideComponent = () => {
// 	if(ShoppingStartContext.data){
// 		if (ShoppingStartContext.data.bonusFlag === 1 && ShoppingStartContext.data.lotteryFlag === 1) { //ボーナス有効、くじ有効
// 			return (
// 				<div className="regigoBannerSlide_frame">
// 					<BannerComponent/>
// 					<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={onBnPrevBtn}>
// 						<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
// 					</div>
// 					<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={onBnNextBtn}>
// 						<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
// 					</div>
// 				</div>
// 			)
// 		}else{
// 			return (
// 				<BannerComponent/>
// 			)
// 		}
// 	}
// }


//----------------------------------------
//買物金額、ボーナス、くじ表示
//----------------------------------------

useEffect(() => {
	if(ShoppingStartContext.data){
		if (ShoppingStartContext.data.bonusFlag === 1 && ShoppingStartContext.data.lotteryFlag === 0) { //ボーナス有効、くじ無効
			if(props.shoppingData){
				if (props.shoppingData.data) { //SUCCESS

					if(props.shoppingData.data.campaign.gustBonusAmount === 0 && props.shoppingData.data.campaign.bonusAmount === 0){ //売上なし
						props.setBonusAmount(0);
						props.setLotteryTimes(0);
						props.setGetAtState([false,false]);
					}else if(props.shoppingData.data.campaign.gustBonusAmount === 0 && props.shoppingData.data.campaign.bonusAmount !== 0){ //上限金額
						if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount){
							console.log("【props.getAtChange】: " + props.getAtChange);
							if(props.getAtChange === true){
								props.setGetAtChange(false);
								setTimeout(function(){
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(0);
									props.setGetAtState([false,true]);
								}, 1000);
							}else{
								props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
								props.setLotteryTimes(0);
								props.setGetAtState([false,true]);
							}
						}else{
							props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
							props.setLotteryTimes(0);
							props.setGetAtState([false,false]);
						}
					}else{ //通常表示
						if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount){
							console.log("【props.getAtChange】: " + props.getAtChange);
							if(props.getAtChange === true){
								props.setGetAtChange(false);
								setTimeout(function(){
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(0);
									props.setGetAtState([false,true]);
								}, 1000);
							}else{
								props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
								props.setLotteryTimes(0);
								props.setGetAtState([false,true]);
							}
						}else{
							props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
							props.setLotteryTimes(0);
							props.setGetAtState([false,false]);
						}
					}

				}else{ //売上なし
					props.setBonusAmount(0);
					props.setLotteryTimes(0);
					props.setGetAtState([false,false]);
				}
			}else{ //売上なし
				props.setBonusAmount(0);
				props.setLotteryTimes(0);
				props.setGetAtState([false,false]);
			}
		}else if (ShoppingStartContext.data.bonusFlag === 0 && ShoppingStartContext.data.lotteryFlag === 1) { //ボーナス無効、くじ有効
			if(props.shoppingData){
				if (props.shoppingData.data) { //SUCCESS
					if(props.shoppingData.data.campaign.gustLotteryAmount === 0 && props.shoppingData.data.campaign.lotteryTimes === 0){ //売上なし
						props.setBonusAmount(0);
						props.setLotteryTimes(0);
						props.setGetAtState([false,false]);
					}else if(props.shoppingData.data.campaign.gustLotteryAmount === 0 && props.shoppingData.data.campaign.lotteryTimes !== 0){ //上限回数
						if(props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
							console.log("【props.getAtChange】: " + props.getAtChange);
							if(props.getAtChange === true){
								props.setGetAtChange(false);
								setTimeout(function(){
									props.setBonusAmount(0);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,false]);
								}, 1000);
							}else{
								props.setBonusAmount(0);
								props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
								props.setGetAtState([true,false]);
							}
						}else{
							props.setBonusAmount(0);
							props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
							props.setGetAtState([false,false]);
						}
					}else{ //通常表示
						if(props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
							console.log("【props.getAtChange】: " + props.getAtChange);
							if(props.getAtChange === true){
								props.setGetAtChange(false);
								setTimeout(function(){
									props.setBonusAmount(0);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,false]);
								}, 1000);
							}else{
								props.setBonusAmount(0);
								props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
								props.setGetAtState([true,false]);
							}
						}else{
							props.setBonusAmount(0);
							props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
							props.setGetAtState([false,false]);
						}
					}

				}else{ //売上なし
					props.setBonusAmount(0);
					props.setLotteryTimes(0);
					props.setGetAtState([false,false]);
				}
			}else{ //売上なし
				props.setBonusAmount(0);
				props.setLotteryTimes(0);
				props.setGetAtState([false,false]);
			}
		}else if (ShoppingStartContext.data.bonusFlag === 1 && ShoppingStartContext.data.lotteryFlag === 1) { //ボーナス有効、くじ有効
			if(props.shoppingData){ //ボーナス
				if (props.shoppingData.data) { //SUCCESS
					if(props.shoppingData.data.campaign.gustBonusAmount === 0 && props.shoppingData.data.campaign.bonusAmount === 0){ //ボーナス売上なし
						if(props.shoppingData.data.campaign.gustLotteryAmount === 0 && props.shoppingData.data.campaign.lotteryTimes === 0){ //くじ売上なし
							props.setBonusAmount(0);
							props.setLotteryTimes(0);
							props.setGetAtState([false,false]);
						}else if(props.shoppingData.data.campaign.gustLotteryAmount === 0 && props.shoppingData.data.campaign.lotteryTimes !== 0){ //くじ上限回数
							if(props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(0);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,false]);
									}, 1000);
								}else{
									props.setBonusAmount(0);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,false]);
								}
							}else{
								props.setBonusAmount(0);
								props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
								props.setGetAtState([false,false]);
							}
						}else{ //くじ通常表示
							if(props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(0);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,false]);
									}, 1000);
								}else{
									props.setBonusAmount(0);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,false]);
								}
							}else{
								props.setBonusAmount(0);
								props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
								props.setGetAtState([false,false]);
							}
						}
					}else if(props.shoppingData.data.campaign.gustBonusAmount === 0 && props.shoppingData.data.campaign.bonusAmount !== 0){ //ボーナス上限金額
						if(props.shoppingData.data.campaign.gustLotteryAmount === 0 && props.shoppingData.data.campaign.lotteryTimes === 0){ //くじ売上なし
							if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(0);
										props.setGetAtState([false,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(0);
									props.setGetAtState([false,true]);
								}
							}else{
								props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
								props.setLotteryTimes(0);
								props.setGetAtState([false,false]);
							}
						}else if(props.shoppingData.data.campaign.gustLotteryAmount === 0 && props.shoppingData.data.campaign.lotteryTimes !== 0){ //くじ上限回数
							if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount && props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,true]);
								}
							}else if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([false,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([false,true]);
								}
							}else if(props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,false]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,false]);
								}
							}else{
								props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
								props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
								props.setGetAtState([false,false]);
							}
						}else{ //くじ通常表示
							if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount && props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,true]);
								}
							}else if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([false,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([false,true]);
								}
							}else if(props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,false]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,false]);
								}
							}else{
								props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
								props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
								props.setGetAtState([false,false]);
							}
						}
					}else{ //ボーナス通常表示
						if(props.shoppingData.data.campaign.gustLotteryAmount === 0 && props.shoppingData.data.campaign.lotteryTimes === 0){ //くじ売上なし
							if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(0);
										props.setGetAtState([false,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(0);
									props.setGetAtState([false,true]);
								}
							}else{
								props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
								props.setLotteryTimes(0);
								props.setGetAtState([false,false]);
							}
						}else if(props.shoppingData.data.campaign.gustLotteryAmount === 0 && props.shoppingData.data.campaign.lotteryTimes !== 0){ //くじ上限回数
							if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount && props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,true]);
								}
							}else if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([false,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([false,true]);
								}
							}else if(props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,false]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,false]);
								}
							}else{
								props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
								props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
								props.setGetAtState([false,false]);
							}
						}else{ //くじ通常表示
							if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount && props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,true]);
								}
							}else if(props.shoppingData.data.campaign.bonusAmount > props.bonusAmount){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([false,true]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([false,true]);
								}
							}else if(props.shoppingData.data.campaign.lotteryTimes > props.lotteryTimes){
								console.log("【props.getAtChange】: " + props.getAtChange);
								if(props.getAtChange === true){
									props.setGetAtChange(false);
									setTimeout(function(){
										props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
										props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
										props.setGetAtState([true,false]);
									}, 1000);
								}else{
									props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
									props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
									props.setGetAtState([true,false]);
								}
							}else{
								props.setBonusAmount(props.shoppingData.data.campaign.bonusAmount);
								props.setLotteryTimes(props.shoppingData.data.campaign.lotteryTimes);
								props.setGetAtState([false,false]);
							}
						}
					}

				}else{ //ボーナス売上なし、くじ売上なし
					props.setBonusAmount(0);
					props.setLotteryTimes(0);
					props.setGetAtState([false,false]);
				}
			}else{ //ボーナス売上なし、くじ売上なし
				props.setBonusAmount(0);
				props.setLotteryTimes(0);
				props.setGetAtState([false,false]);
			}
		}
	}
}, [ShoppingStartContext.data,props.shoppingData]);


return (
<>
<header className={`shoppingHeader is_noitem ${bandColor}`} >
	<div className="shoppingHeader_main">
		<p className="shoppingHeader_num">
		{
			(() => {
				if (props.shoppingData) {
					if (props.shoppingData.data) { // SUCCESS
						if (props.shoppingData.data.sumItemCount !== 0) { //カート商品：0件以外
							return (
								<>
								<span className="shoppingHeader_num_icn">
									<img src="/images/icn_cart02.svg" alt="" width="30" height="30"/>
								</span>
								{props.shoppingData.data.sumItemCount}
								</>
							)
						}else{ //カート商品：0件
							return (
								<>
								<span className="shoppingHeader_num_icn">
									<img src="/images/icn_cart01.svg" alt="" width="30" height="30"/>
								</span>
								0
								</>
							)
						}
					} else { //カート商品：0件
						return (
							<>
							<span className="shoppingHeader_num_icn">
								<img src="/images/icn_cart01.svg" alt="" width="30" height="30"/>
							</span>
							0
							</>
						)
					}
				} else { //カート商品：0件
					return (
						<>
						<span className="shoppingHeader_num_icn">
							<img src="/images/icn_cart01.svg" alt="" width="30" height="30"/>
						</span>
						0
						</>
					)
				}
			})()
		}
			<small>点</small></p>
		<p className="shoppingHeader_price01"><small>合計</small><span>¥</span>
		{
			(() => {
				if(props.shoppingData){
					if (props.shoppingData.data) { //SUCCESS
						return (props.shoppingData.data.sumSellPrice).toLocaleString('ja-JP');
						// return 0;
					}else{ //ERROR
						return 0;
					}
				}else{
					return 0;
				}
			})()
		}
		</p>
	</div>
	<div className="shoppingHeader_sub">
		<div className="shoppingHeader_codeRenkei_label">
			<div className="codeRenkei_circle is_active">
				<span className="codeRenkei_circle01"></span>
			</div>
			<span className="shoppingHeader_codeRenkei_label_txt">iAEON会員コード認証済</span>
		</div>
		<p className="shoppingHeader_price02"><small>税込</small> <span>¥ </span>
		{
			(() => {
				if(props.shoppingData){
					if (props.shoppingData.data) { //SUCCESS
						return (props.shoppingData.data.sumIncludeTaxPrice).toLocaleString('ja-JP');
						// return 0;
					}else{ //ERROR
						return 0;
					}
				}else{
					return 0;
				}
			})()
		}
		</p>
	</div>
</header>


{/* <div className="regigoBannerSlide_frame">
	<Slider {...settings} ref={sliderRef} className="regigoBannerSlide">
		<div className="regigoBannerSlide_box">
			<div className="regigoBanner regigoBanner_bonus">
				<span className="regigoBanner_bg"><img src="/images/kuji/bn_bonus01.png" alt="" width="358" height="72" /></span>
			</div>
		</div>
		<div className="regigoBannerSlide_box">
			<div className="regigoBanner regigoBanner_kuji">
				<span className="regigoBanner_bg"><img src="/images/kuji/bn_kuji01.png" alt="" width="358" height="72" /></span>
			</div>
		</div>
	</Slider>
	<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
		<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
	</div>
	<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
		<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
	</div>
</div> */}
{/* <div className="regigoBannerSlide_frame"> */}
{/* <BannerComponentMemo/> */}
<BannerComponent shopData={props.shoppingData} />
	{/* <div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
		<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
	</div>
	<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
		<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
	</div>
</div> */}

{/* {
	(() => {
	if(ShoppingStartContext.data){
		if (ShoppingStartContext.data.bonusFlag === 1 && ShoppingStartContext.data.lotteryFlag === 1) { //ボーナス有効、くじ有効
			return (
				<div className="regigoBannerSlide_frame">
					<BannerComponent/>
					<div className="regigoBannerSlide_btn regigoBannerSlide_prevBtn" onClick={()=>{onBnPrevBtn()}}>
						<img src="/images/kuji/btn_prev.svg" alt="" width="14" height="56"/>
					</div>
					<div className="regigoBannerSlide_btn regigoBannerSlide_nextBtn" onClick={()=>{onBnNextBtn()}}>
						<img src="/images/kuji/btn_next.svg" alt="" width="14" height="56"/>
					</div>
				</div>
			)
		}else{
			return (
				<BannerComponent/>
			)
		}
	}
	})()
} */}

<ShoppingList item={props.item} setItem={props.setItem} showItemNum={props.showItemNum} setShowItemNum={props.setShowItemNum} delModal={props.delModal} setDelModal={props.setDelModal} shoppingStData={props.shoppingStData} shoppingData={props.shoppingData} soundState={props.soundState} setSoundState={props.setSoundState} shoppingArr={props.shoppingArr} setShoppingArr={props.setShoppingArr} appHeight={props.appHeight} setAppHeight={props.setAppHeight}/>

{/* <ScrollPosition /> */}
<nav className="shoppingNav">
	{/* <button id="scanBtn" className="shoppingNav_scanBtn is_disabled" onClick={scanItem}> */}
	<button id="scanBtn" className={`shoppingNav_scanBtn ${props.isScanButtonDisabled ? "is_disabled02" : ""}`} onClick={scanItem}>
		<span>
			<span className="shoppingNav_scanBtn_icn">
				<img src="/images/icn_camera.svg" alt="" width="32" height="32"/>
			</span>
			スキャン
		</span>
	</button>
	<div className="shoppingNav_box">
		<button className={`shoppingNav_nobarcodeBtn ${props.keypluFlg === true ? '' : 'is_disabled'}`} onClick={onNoBarcode}>
			<span>
				<span className="shoppingNav_nobarcodeBtn_icn">
					<img src="/images/icn_nobarcode.svg" alt="" width="32" height="32"/>
				</span>
				バーコードの無い商品
			</span>
		</button>
		<ul className="shoppingNav_list">
			<li className="shoppingNav_list_box">
				<button className="shoppingNav_listBtn coupon is_disabled">
					<figure className="shoppingNav_listBtn_img">
						<img src="/images/icn_coupon.svg" alt="" width="26" height="26"/>
					</figure>
					<span className="shoppingNav_listBtn_txt">お得情報</span>
				</button>
			</li>
			<li className="shoppingNav_list_box">
				{
					(() => {
						if (props.shoppingData) {
							if (props.shoppingData.data) { // SUCCESS
								if (props.shoppingData.data.sumItemCount !== 0) { // SUCCESS
								// return props.shoppingData.data.sumItemCount;
								return <button className={`shoppingNav_listBtn payment ${props.isKaikeiButtonDisabled ? "disabled" : ""}`} onClick={ShowPayModal}>
									<figure className="shoppingNav_listBtn_img">
										<span><img src="/images/icn_checkout_grey.svg" alt="" width="26" height="26"/></span>
										<img src="/images/icn_checkout.svg" alt="" width="26" height="26"/>
									</figure>
									<span className="shoppingNav_listBtn_txt">お会計</span>
								</button>
								}else{
									return <button className={`shoppingNav_listBtn payment is_noitem ${props.isKaikeiButtonDisabled ? "disabled" : ""}`} onClick={ShowPayModal}>
										<figure className="shoppingNav_listBtn_img">
											<span><img src="/images/icn_checkout_grey.svg" alt="" width="26" height="26"/></span>
											<img src="/images/icn_checkout.svg" alt="" width="26" height="26"/>
										</figure>
										<span className="shoppingNav_listBtn_txt">お会計</span>
									</button>
								}
							} else { // ERROR
								return <button className={`shoppingNav_listBtn payment is_noitem ${props.isKaikeiButtonDisabled ? "disabled" : ""}`} onClick={ShowPayModal}>
									<figure className="shoppingNav_listBtn_img">
										<span><img src="/images/icn_checkout_grey.svg" alt="" width="26" height="26"/></span>
										<img src="/images/icn_checkout.svg" alt="" width="26" height="26"/>
									</figure>
									<span className="shoppingNav_listBtn_txt">お会計</span>
								</button>
							}
						} else {
							return <button className={`shoppingNav_listBtn payment is_noitem ${props.isKaikeiButtonDisabled ? "disabled" : ""}`} onClick={ShowPayModal}>
								<figure className="shoppingNav_listBtn_img">
									<span><img src="/images/icn_checkout_grey.svg" alt="" width="26" height="26"/></span>
									<img src="/images/icn_checkout.svg" alt="" width="26" height="26"/>
								</figure>
								<span className="shoppingNav_listBtn_txt">お会計</span>
							</button>
						}
					})()
				}
			</li>
		</ul>
	</div>
</nav>
</>
)

}
